import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateStripeBillingPortalSessionMutationVariables = Types.Exact<{
  organizationId: Types.Scalars['ID']['input'];
  returnUrlPath?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateStripeBillingPortalSessionMutation = { __typename: 'Mutation', createStripeBillingPortalSession: string };

export type SubscriptionPlansForSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SubscriptionPlansForSettingsQuery = { __typename: 'Query', subscriptionPlans: string };

export type CreateCheckoutSessionFromSettingsMutationVariables = Types.Exact<{
  priceLookupKey: Types.Scalars['String']['input'];
  successUrl: Types.Scalars['String']['input'];
  cancelUrl: Types.Scalars['String']['input'];
}>;


export type CreateCheckoutSessionFromSettingsMutation = { __typename: 'Mutation', createCheckoutSession: string };

export type EndTrialNowFromSettingsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type EndTrialNowFromSettingsMutation = { __typename: 'Mutation', endTrialNow: { __typename: 'Organization', id: string } };

export type GetOrganizationForSettingsQueryVariables = Types.Exact<{
  organizationId: Types.Scalars['ID']['input'];
}>;


export type GetOrganizationForSettingsQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, name?: string | null, accountType: Types.AccountType, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, stripePriceId?: string | null, stripeProductName?: string | null, stripeSubscriptionStatus?: string | null, stripeCurrentPeriodEnd?: string | null, stripeCancelAtPeriodEnd?: boolean | null, trialEndsAt?: string | null, membersCount: number, members: Array<{ __typename: 'Membership', id: string, role: Types.MembershipRole, user: { __typename: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } }> } };

export const CreateStripeBillingPortalSessionDocument = gql`
    mutation CreateStripeBillingPortalSession($organizationId: ID!, $returnUrlPath: String) {
  createStripeBillingPortalSession(
    organizationId: $organizationId
    returnUrlPath: $returnUrlPath
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStripeBillingPortalSessionGQL extends Apollo.Mutation<CreateStripeBillingPortalSessionMutation, CreateStripeBillingPortalSessionMutationVariables> {
    override document = CreateStripeBillingPortalSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubscriptionPlansForSettingsDocument = gql`
    query SubscriptionPlansForSettings {
  subscriptionPlans
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscriptionPlansForSettingsGQL extends Apollo.Query<SubscriptionPlansForSettingsQuery, SubscriptionPlansForSettingsQueryVariables> {
    override document = SubscriptionPlansForSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCheckoutSessionFromSettingsDocument = gql`
    mutation CreateCheckoutSessionFromSettings($priceLookupKey: String!, $successUrl: String!, $cancelUrl: String!) {
  createCheckoutSession(
    input: {priceLookupKey: $priceLookupKey, successUrl: $successUrl, cancelUrl: $cancelUrl, skipTrial: true}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCheckoutSessionFromSettingsGQL extends Apollo.Mutation<CreateCheckoutSessionFromSettingsMutation, CreateCheckoutSessionFromSettingsMutationVariables> {
    override document = CreateCheckoutSessionFromSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EndTrialNowFromSettingsDocument = gql`
    mutation EndTrialNowFromSettings {
  endTrialNow(input: {}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EndTrialNowFromSettingsGQL extends Apollo.Mutation<EndTrialNowFromSettingsMutation, EndTrialNowFromSettingsMutationVariables> {
    override document = EndTrialNowFromSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationForSettingsDocument = gql`
    query GetOrganizationForSettings($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    accountType
    stripeCustomerId
    stripeSubscriptionId
    stripePriceId
    stripeProductName
    stripeSubscriptionStatus
    stripeCurrentPeriodEnd
    stripeCancelAtPeriodEnd
    trialEndsAt
    members {
      id
      role
      user {
        id
        firstName
        lastName
        email
      }
    }
    membersCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationForSettingsGQL extends Apollo.Query<GetOrganizationForSettingsQuery, GetOrganizationForSettingsQueryVariables> {
    override document = GetOrganizationForSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }